import { EmailProviderOption, SmsProviderOption } from '@client-models/integration.model';
import { WIDGET_APPOINTMENT_TYPE } from '@constants/partner-settings.constants';
import { LanguagesModel } from '@db-models/language.model';
import { environment } from '@environments/environment';

export const CALENSO_PARTNER_DATA = {
  partnerId: 6,
} as const;

export const APP_CONSTANTS = {
  DEFAULT_CALENSO_PARTNER_NAME: 'calenso',
  CALENSO_SUPPORT_EMAIL: 'support@calenso.com',
  APPOINTMENT: 'APPOINTMENT',
  EVENT: 'EVENT',
  COMPACT: 'COMPACT',
  CONFERENCE: 'CONFERENCE',
  PRE_DEFINED_SLOTS: 'PRE_DEFINED_SLOTS',
  TOUR: 'TOUR',
  ANY: 'ANY',
  WORKER: 'WORKER',
  WEBHOOK: 'WEBHOOK',
  LEADTIME: 'LEADTIME',
  GENERAL: 'GENERAL',

  LIST: 'LIST',
  GRID: 'GRID',

  ADD: 'ADD',
  EDIT: 'EDIT',
  CREATE: 'CREATE',

  AVAILABILITIES_FORM: 'AVAILABILITIES_FORM',
  EXCEPTIONAL_AVAILABILITIES_FORM: 'EXCEPTIONAL_AVAILABILITIES_FORM',

  APPOINTMENT_SERVICE_NEW_FORM_TYPE: 'APPOINTMENT_SERVICE_NEW_FORM_TYPE',
  APPOINTMENT_SERVICE_CATEGORY_FORM_TYPE: 'APPOINTMENT_SERVICE_CATEGORY_FORM_TYPE',
  APPOINTMENT_SERVICE_EDIT_FORM_TYPE: 'APPOINTMENT_SERVICE_EDIT_FORM_TYPE',

  APPOINTMENT_SERVICE_CATEGORY_NEW_FORM_TYPE: 'APPOINTMENT_SERVICE_CATEGORY_NEW_FORM_TYPE',
  APPOINTMENT_SERVICE_CATEGORY_EDIT_FORM_TYPE: 'APPOINTMENT_SERVICE_CATEGORY_EDIT_FORM_TYPE',

  CATEGORY_NEW_FORM_TYPE: 'CATEGORY_NEW_FORM_TYPE',
  CATEGORY_EDIT_FORM_TYPE: 'CATEGORY_EDIT_FORM_TYPE',

  CUSTOMER_TYPE_NEW_FORM_TYPE: 'CUSTOMER_TYPE_NEW_FORM_TYPE',
  CUSTOMER_TYPE_EDIT_FORM_TYPE: 'CUSTOMER_TYPE_EDIT_FORM_TYPE',

  STORE_NEW_FORM_TYPE: 'STORE_NEW_FORM_TYPE',
  STORE_EDIT_FORM_TYPE: 'STORE_EDIT_FORM_TYPE',

  APPOINTMENT_STATUS_NEW_FORM_TYPE: 'APPOINTMENT_STATUS_NEW_FORM_TYPE',
  APPOINTMENT_STATUS_EDIT_FORM_TYPE: 'APPOINTMENT_STATUS_EDIT_FORM_TYPE',

  APPOINTMENT_GROUP_NEW_FORM_TYPE: 'APPOINTMENT_GROUP_NEW_FORM_TYPE',
  APPOINTMENT_GROUP_EDIT_FORM_TYPE: 'APPOINTMENT_GROUP_EDIT_FORM_TYPE',

  TAX_NEW_FORM_TYPE: 'TAX_NEW_FORM_TYPE',
  TAX_EDIT_FORM_TYPE: 'TAX_EDIT_FORM_TYPE',

  DEAL_NEW_FORM_TYPE: 'DEAL_NEW_FORM_TYPE',
  DEAL_EDIT_FORM_TYPE: 'DEAL_EDIT_FORM_TYPE',

  DEAL_AMOUNT_SCREEN: 'DEAL_AMOUNT_SCREEN',
  DEAL_DURATION_SCREEN: 'DEAL_DURATION_SCREEN',
  DEAL_COUPON_SCREEN: 'DEAL_COUPON_SCREEN',

  STORE_ONLINE: 'STORE_ONLINE',
  STORE_OFFLINE: 'STORE_OFFLINE',

  REFUNDED_ON_CANCELLATION_REMARK: 'refunded_on_cancellation',

  QUESTION_FIELD_NEW_FORM_TYPE: 'QUESTION_FIELD_NEW_FORM_TYPE',
  QUESTION_FIELD_EDIT_FORM_TYPE: 'QUESTION_FIELD_EDIT_FORM_TYPE',
  QUESTION_FIELD_MULTILANGUAGE_FORM_TYPE: 'QUESTION_FIELD_MULTILANGUAGE_FORM_TYPE',

  INTEGRATION_IFRAME: 'INTEGRATION_IFRAME',
  INTEGRATION_WEBCOMPONENT: 'INTEGRATION_WEBCOMPONENT',
  INTEGRATION_EMAIL_SIGNATURE: 'INTEGRATION_EMAIL_SIGNATURE',

  RESELLER_INTEGRATION_WEBCOMPONENT: 'RESELLER_INTEGRATION_WEBCOMPONENT',
  RESELLER_INTEGRATION_IFRAME: 'RESELLER_INTEGRATION_IFRAME',
  RESELLER_INTEGRATION_URL: 'RESELLER_INTEGRATION_URL',
  EMPLOYEE_NEW_FORM_TYPE: 'EMPLOYEE_NEW_FORM_TYPE',
  RESOURCE_NEW_FORM_TYPE: 'RESOURCE_NEW_FORM_TYPE',
  EMPLOYEE_EDIT_FORM_TYPE: 'EMPLOYEE_EDIT_FORM_TYPE',
  RESOURCE_EDIT_FORM_TYPE: 'RESOURCE_EDIT_FORM_TYPE',
  AVAILABILITIES_FIRST_SCREEN: 'AVAILABILITIES_FIRST_SCREEN',
  AVAILABILITIES_RECURRING_SCREEN: 'AVAILABILITIES_RECURRING_SCREEN',
  AVAILABILITIES_ABSENCES_SCREEN: 'AVAILABILITIES_ABSENCES_SCREEN',
  CUSTOM_ABSENCES_SCREEN: 'CUSTOM_ABSENCES_SCREEN',
  IMPORT_HOLIDAYS_ABSENCES_SCREEN: 'IMPORT_HOLIDAYS_ABSENCES_SCREEN',
  EVENTS_BASIC_SCREEN: 'EVENTS_BASIC_SCREEN',
  EVENTS_NOTIFICATION_SCREEN: 'EVENTS_NOTIFICATION_SCREEN',
  EVENTS_CANCELLATION_SCREEN: 'EVENTS_CANCELLATION_SCREEN',
  URL_REGEX: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
  NEW_URL_REGEX: /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[^\s]*)?$/,
  EMAIL_REGEX: /^[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,})$/iu,
  PLACEHOLDER_MULTIPLE_EMAIL_REGEX: /^(\s*(\{\{\s*[A-Z_]+\s*\}\}|[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,}))\s*)(,\s*(\{\{\s*[A-Z_]+\s*\}\}|[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,}))\s*)*$/iu,
  PLACEHOLDER_EMAIL_REGEX: /^(\s*(\{\{\s*[A-Z_]+\s*\}\}|[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,}))\s*)$/iu,
  PLACEHOLDER_PHONE_REGEX: /^(?:\{\{\s*[A-Z_]+\s*\}\}|(\+?[0-9]{5,15}))$/,
  // Recipient of a workflow "Trigger export" action: ONE plain address, or {{ PARTNER_EMAIL }}.
  // An export mails a whole data set, so customer/resource placeholders are deliberately excluded
  // (the workflow service leaves them unresolved and skips the action).
  // The address half MIRRORS the workflow service's `DefaultConfig.EMAIL_REGEX` — including its
  // `\p{L}` unicode classes, so an address like jörg@müller.ch stays saveable — because a value this
  // accepts is validated again by that regex at run time. Surrounding whitespace is tolerated for
  // pasted values and stripped on save, so the stored value always satisfies the stricter service side.
  EXPORT_RECIPIENT_EMAIL_PATTERN:
    /^\s*(?:\{\{\s*PARTNER_EMAIL\s*\}\}|[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,}))\s*$/iu,
  // E.164 phone-number format Twilio's REST API expects for the "From" field:
  // leading `+`, country code (1-9), 9-14 trailing digits. Matches +14055262534
  // (US, 11 digits total) up to +491701234567890 (DE, 15 digits total).
  TWILIO_FROM_NUMBER_REGEX: /^\+[1-9][0-9]{9,14}$/,
  TWILIO_FROM_NUMBER_MIN_LENGTH: 11,
  TWILIO_FROM_NUMBER_MAX_LENGTH: 16,
  // Shared bounds for Twilio Account SID (`AC` + 32 hex) and Auth Token (32 hex); range left permissive.
  TWILIO_CREDENTIAL_MIN_LENGTH: 32,
  TWILIO_CREDENTIAL_MAX_LENGTH: 64,
  WORKER_PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.{8,})/g,
  WORKER_USERNAME_REGEX: /^[A-Za-z0-9_@./!#$%&.'*+-/=?^_]+$/,
  WORKER_CONFERENCE_URL_REGEX: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?$/,
  IP_REGEX: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(?:[0-9]|[1-2][0-9]|3[0-2])$|^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  COMMON_ZIP_REGEX: /^[a-zA-Z0-9\s-]{1,10}$/,
  ZIP_REGEX: /^(?=.*\d)[a-zA-Z0-9\s-]{2,10}$/,
  HOST_REGEX: /^(?=.{1,253}$)(?:(?!-)[A-Za-z0-9-]{1,63}(?<!-)\.?)+[A-Za-z]{2,6}$/,
  PORT_REGEX: /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
  HEADER_REGEX: /^[a-zA-Z][a-zA-Z0-9_-]*$/,
  VALUE_REGEX: /^(?!\s*$)[a-zA-Z0-9\s]+$/,
  INFO_URL_REGEX: /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/,
  CUSTOM_EMAIL_TEMPLATE_PLACEHOLDER_REGEX: /^(|\s*(.|\n)*{{\s*body\s*}}(.|\n)*\s*)$/,
  ALPHANUMERIC: /^[a-zA-Z0-9_\- ]*$/,
  NUNBER_ONLY: /^\d+$/,
  BOOKING_NAME_REGEX: /^[a-zA-Z0-9äöüÄÖÜß]+$/,
  BOOKING_QUESTION_IDENTIFIER_REGEX: /^(?=.*[A-Za-z_-])[A-Za-z0-9_-]{1,64}$/,
  IDEAL_REGEX: /^((\\.|[^\\[\]{}()|])|(\[[^\]]*\])|(\([^)]*\))|(\{[0-9,]*\}))*$/,
  COMMA_SEPARATED_REGEX: /^[^,]+(,[^,]+)*$/,
  DOMAIN_REGEX: /^(?!-)([a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,}$/,
  // A Microsoft Entra / Azure AD GUID (8-4-4-4-12 hex): tenant id, directory object id, group id.
  GUID_REGEX: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,

  // tslint:disable: quotemark
  REGEX_PATTERNS: [
    {
      name: 'regex_pattern.only_uppercase',
      pattern: '^[A-Z]+$',
    },
    {
      name: 'regex_pattern.only_lowercase',
      pattern: '^[a-z]+$',
    },
    {
      name: 'regex_pattern.only_numbers',
      pattern: '^[0-9]+$',
    },
    {
      name: 'regex_pattern.only_letters',
      pattern: '^[a-zA-Z]+$',
    },
    {
      name: 'regex_pattern.only_letters_and_numbers',
      pattern: '^[a-zA-Z0-9]+$',
    },
    {
      name: 'regex_pattern.only_letters_and_numbers_with_spaces',
      pattern: '^[a-zA-Z0-9 ]+$',
    },
    {
      name: 'regex_pattern.only_letters_and_numbers_without_spaces',
      pattern: '^[a-zA-Z0-9]+$',
    },
    {
      name: 'regex_pattern.insurance_number',
      pattern: '^(807)[0-9]{17}$',
    },
    {
      name: 'regex_pattern.phone_number',
      pattern: '^[0-9]{10}$',
    },
    {
      name: 'regex_pattern.ahv_number',
      pattern: '^(756)[0-9.]{13}$',
    },
    {
      name: 'regex_pattern.iban_number',
      pattern: '^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$',
    },
    {
      name: 'regex_pattern.url',
      pattern: "^(?:http(s)?://)?[w.-]+(?:.[w.-]+)+[w-._~:/?#[]@!$&'()*+,;=.]+$",
    },
    {
      name: 'regex_pattern.email',
      pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$',
    },
    {
      name: 'regex_pattern.custom',
      pattern: ''
    }
  ],
  // tslint:enable: quotemark

  COLORS: [
    {
      label: 'Danger',
      value: 'danger'
    },
    {
      label: 'Dark',
      value: 'dark'
    },
    {
      label: 'Info',
      value: 'info'
    },
    {
      label: 'Light',
      value: 'light'
    },
    {
      label: 'Primary',
      value: 'primary'
    },
    {
      label: 'Secondary',
      value: 'secondary'
    },
    {
      label: 'Success',
      value: 'success'
    },
    {
      label: 'Warning',
      value: 'warning'
    },
  ],

  DAYS: [
    {
      sn_text: 'mon',
      ln_text: 'monday',
      value: 1,
      calValue: 1,
    },
    {
      sn_text: 'tue',
      ln_text: 'tuesday',
      value: 2,
      calValue: 2,
    },
    {
      sn_text: 'wed',
      ln_text: 'wednesday',
      value: 3,
      calValue: 3,
    },
    {
      sn_text: 'thu',
      ln_text: 'thursday',
      value: 4,
      calValue: 4,
    },
    {
      sn_text: 'fri',
      ln_text: 'friday',
      value: 5,
      calValue: 5,
    },
    {
      sn_text: 'sat',
      ln_text: 'saturday',
      value: 6,
      calValue: 6,
    },
    {
      sn_text: 'sun',
      ln_text: 'sunday',
      value: 7,
      calValue: 0,
    },
  ],
  PUBLIC_HOLIDAY_TYPES: {
    SWISS: [
      {
        text: 'school_holidays_text_1',
        value: 0,
      },
      {
        text: 'school_holidays_text_2',
        value: 3,
      },
      {
        text: 'school_holidays_text_3',
        value: 4,
      },
      {
        text: 'school_holidays_text_4',
        value: 5,
      },
    ],
    OTHER_LANGS: [
      {
        text: 'other_school_holidays_text_2',
        value: 3,
      },
      {
        text: 'other_school_holidays_text_3',
        value: 4,
      },
      {
        text: 'other_school_holidays_text_4',
        value: 5,
      },
    ],
  },
  LANGUAGES: [
    {
      text: 'german',
      origin_text: 'Deutsch (Schweiz)',
      value: 'de',
      secondary_text: 'DE',
      locale: 'de_CH',
      flagIcon: '/assets/images/flags/de_CH.png',
    },
    {
      text: 'english',
      origin_text: 'English (United States)',
      value: 'en',
      secondary_text: 'EN',
      locale: 'en_US',
      flagIcon: '/assets/images/flags/en_US.png',
    },
    {
      text: 'spanish',
      origin_text: 'Español (España)',
      value: 'es',
      secondary_text: 'ES',
      locale: 'es_ES',
      flagIcon: '/assets/images/flags/es_ES.png',
    },
    {
      text: 'french',
      origin_text: 'Français (Suisse)',
      value: 'fr',
      secondary_text: 'FR',
      locale: 'fr_CH',
      flagIcon: '/assets/images/flags/fr_CH.png',
    },
    {
      text: 'italian',
      origin_text: 'Italiano (Svizzera)',
      value: 'it',
      secondary_text: 'IT',
      locale: 'it_CH',
      flagIcon: '/assets/images/flags/it_CH.png',
    },
    {
      text: 'dutch',
      origin_text: 'Nederlands (Nederland)',
      value: 'nl',
      secondary_text: 'NL',
      locale: 'nl_NL',
      flagIcon: '/assets/images/flags/nl_NL.png',
    },
    {
      text: 'polish',
      origin_text: 'Polski (Polska)',
      value: 'pl',
      secondary_text: 'PL',
      locale: 'pl_PL',
      flagIcon: '/assets/images/flags/pl_PL.png',
    },
    {
      text: 'finnish',
      origin_text: 'Suomi (Suomi)',
      value: 'fi',
      secondary_text: 'FI',
      locale: 'fi_FI',
      flagIcon: '/assets/images/flags/fi_FI.png',
    },
    {
      text: 'swedish',
      origin_text: 'Svenska (Sverige)',
      value: 'sv',
      secondary_text: 'SE',
      locale: 'sv_SE',
      flagIcon: '/assets/images/flags/sv_SE.png',
    },
  ] as LanguagesModel[],

  ALL_DISPLAY_LANGUAGES: [
    {
      text: 'german',
      origin_text: 'Deutsch (Schweiz)',
      value: 'de',
      secondary_text: 'DE',
      locale: 'de_CH',
      flagIcon: '/assets/images/flags/de_CH.png',
    },
    // {
    //   text: 'english (AU)',
    //   origin_text: 'English (Australia)',
    //   value: 'en_au',
    //   secondary_text: 'AU',
    //   locale: 'en_AU',
    //   flagIcon: '/assets/images/flags/en_AU.svg',
    // },
    // {
    //   text: 'english (CA)',
    //   origin_text: 'English (Canada)',
    //   value: 'en_ca',
    //   secondary_text: 'CA',
    //   locale: 'en_CA',
    //   flagIcon: '/assets/images/flags/en_CA.svg',
    // },
    // {
    //   text: 'english (UK)',
    //   origin_text: 'English (United Kingdom)',
    //   value: 'en_gb',
    //   secondary_text: 'GB',
    //   locale: 'en_GB',
    //   flagIcon: '/assets/images/flags/en_GB.svg',
    // },
    {
      text: 'english (US)',
      origin_text: 'English (United States)',
      value: 'en',
      secondary_text: 'US',
      locale: 'en_US',
      flagIcon: '/assets/images/flags/en_US.png',
    },
    {
      text: 'spanish',
      origin_text: 'Español (España)',
      value: 'es',
      secondary_text: 'ES',
      locale: 'es_ES',
      flagIcon: '/assets/images/flags/es_ES.png',
    },
    {
      text: 'french',
      origin_text: 'Français (Suisse)',
      value: 'fr',
      secondary_text: 'FR',
      locale: 'fr_CH',
      flagIcon: '/assets/images/flags/fr_CH.png',
    },
    {
      text: 'italian',
      origin_text: 'Italiano (Svizzera)',
      value: 'it',
      secondary_text: 'IT',
      locale: 'it_CH',
      flagIcon: '/assets/images/flags/it_CH.png',
    },
    {
      text: 'dutch',
      origin_text: 'Nederlands (Nederland)',
      value: 'nl',
      secondary_text: 'NL',
      locale: 'nl_NL',
      flagIcon: '/assets/images/flags/nl_NL.png',
    },
    {
      text: 'polish',
      origin_text: 'Polski (Polska)',
      value: 'pl',
      secondary_text: 'PL',
      locale: 'pl_PL',
      flagIcon: '/assets/images/flags/pl_PL.png',
    },
    {
      text: 'finnish',
      origin_text: 'Suomi (Suomi)',
      value: 'fi',
      secondary_text: 'FI',
      locale: 'fi_FI',
      flagIcon: '/assets/images/flags/fi_FI.png',
    },
    {
      text: 'swedish',
      origin_text: 'Svenska (Sverige)',
      value: 'sv',
      secondary_text: 'SE',
      locale: 'sv_SE',
      flagIcon: '/assets/images/flags/sv_SE.png',
    },
  ] as LanguagesModel[],

  IMAGE_UPLOAD_TYPE: {
    PARTNER_LOGO_UPLOAD: 'PARTNER_LOGO_UPLOAD',
    WORKER_AVATAR_UPLOAD: 'WORKER_AVARTAR_UPLOAD',
    EVENT_IMAGE_UPLOAD: 'EVENT_IMAGE_UPLOAD',
    PARTNER_LANDINGPAGE_LOGO_UPLOAD: 'PARTNER_LANDINGPAGE_LOGO_UPLOAD',
    PARTNER_FAVICON_LOGO_UPLOAD: 'PARTNER_FAVICON_LOGO_UPLOAD',
    PARTNER_EMAIL_LOGO_UPLOAD: 'PARTNER_EMAIL_LOGO_UPLOAD',
    STORE_LOGO_UPLOAD: 'STORE_LOGO_UPLOAD',
    BOOKING_PAGE_BACKGROUND: 'BOOKING_PAGE_BACKGROUND',
    APPOINTMENT_SERVICE_IMAGE_UPLOAD: 'APPOINTMENT_SERVICE_IMAGE_UPLOAD',
  },
  INTEGRATION_FIRST_SCREEN: 'INTEGRATION_FIRST_SCREEN',
  INTEGRATION_BOOKING_MICROSITE_SCREEN: 'INTEGRATION_BOOKING_MICROSITE_SCREEN',
  INTEGRATION_WEBSITE_SCREEN: 'INTEGRATION_WEBSITE_SCREEN',

  PROBLEM_NOTIFICATION: 'problem',
  ANNOUNCEMENT_NOTIFICATION: 'announcement',
  WARNING_NOTIFICATION: 'warning',
  INFORMATION_NOTIFICATION: 'information',

  CASH_ON_SITE_SCREEN: 'CASH_ON_SITE_SCREEN',
  CREDIT_CARD_SCREEN: 'CREDIT_CARD_SCREEN',

  PERCENTAGE_SCREEN: 'PERCENTAGE_SCREEN',
  FIXED_AMOUNT_SCREEN: 'FIXED_AMOUNT_SCREEN',

  REPEATING_DAYS: 'REPEATING_DAYS',
  REPEATING_DATES: 'REPEATING_DATES',

  DE_SCREEN: 'DE',
  EN_SCREEN: 'EN',
  IT_SCREEN: 'IT',
  FR_SCREEN: 'FR',
  NL_SCREEN: 'NL',

  SUPPORTED_COLOR_FORMATS: [
    {
      display: 'neutral_color',
      value: 'neutral',
    },
    {
      display: 'red_color',
      value: 'red',
    },
    {
      display: 'yellow_color',
      value: 'yellow',
    },
    {
      display: 'blue_color',
      value: 'blue',
    },
  ],
};


export const WIDGET_EXPAND_OPTIONS: any[] = [
  {
    display: 'widget_expand_appointment_service_categories_option_1',
    value: 0,
  },
  {
    display: 'widget_expand_appointment_service_categories_option_2',
    value: 1,
  },
  {
    display: 'widget_expand_appointment_service_categories_option_3',
    value: 2,
  },
];

export const CANCELLATION_NOTIFICATION_TYPES = [
  {
    display: 'inform_the_partner',
    value: 1,
  },
  {
    display: 'worker_option',
    value: 2,
  },
  {
    display: 'custom_email_option',
    value: 3,
  },
  {
    display: 'inform_store',
    value: 4,
  },
  {
    display: 'inform_partner_and_resource',
    value: 5,
  },
  {
    display: 'inform_store_and_resource',
    value: 6,
  },
  {
    display: 'inform_partner_and_store',
    value: 7,
  }
];

export const NOTIFICATION_TYPES = [
  {
    display: 'email',
    value: 'email',
  },
  {
    display: 'sms',
    value: 'sms',
  },
  {
    display: 'both_sms_email',
    value: 'both',
  },
];

export const SINGLE_WORKER_NOTIFICATIONS = [
  {
    display: 'inform_the_partner',
    value: 0,
  },
  {
    display: 'inform_each_employee',
    value: 1,
  },
  {
    display: 'inform_resource_and_partner',
    value: 2,
  },
  {
    display: 'inform_store',
    value: 3,
  },
  {
    display: 'inform_store_and_resource',
    value: 4,
  },
  {
    display: 'inform_partner_and_store',
    value: 5,
  },
];

export const APPOINTMENT_CONFIRMATION_TYPES = [
  {
    display: 'inform_each_employee',
    value: 1,
  },
  {
    display: 'inform_the_partner',
    value: 0,
  },
];

export const COURTESY_FORM_TYPES = [
  {
    display: 'informal',
    value: 'Du',
  },
  {
    display: 'formal',
    value: 'Sie',
  },
];

export const HOUR_TYPES = [
  {
    display: '1 ',
    value: 1,
  },
  {
    display: '2 ',
    value: 2,
  },
  {
    display: '3 ',
    value: 3,
  },
  {
    display: '4 ',
    value: 4,
  },
  {
    display: '5 ',
    value: 5,
  },
  {
    display: '6 ',
    value: 6,
  },
  {
    display: '12 ',
    value: 12,
  },
  {
    display: '24 ',
    value: 24,
  },
  {
    display: '36 ',
    value: 36,
  },
  {
    display: '48 ',
    value: 48,
  },
  {
    display: '72 ',
    value: 72,
  },
];

export const DELETE_CONST_TYPE: { [key: string]: string } = {
  ICON: 'ICON',
  SELECTED_DELETE_BUTTON: 'SELECTED_DELETE_BUTTON',
  LABEL_BUTTON: 'LABEL_BUTTON',
};

export const EMPLOYEE_CONST_TYPE = {
  AVATAR: 'AVATAR',
  SELECT: 'SELECT',
};

export const FILE_CONST_TYPE = {
  PDF: 'PDF',
  EXCEL: 'EXCEL',
};

// saveAs() gives no completion event; callers hold their loading state this long.
export const FILE_DOWNLOAD_HANDOFF_MS = 1500;

export const MEETING_TYPE = {
  ZOOM: 'zoom',
  PHONE: 'phone',
  CALENSO: 'calenso',
  STORE: 'store',
  CUSTOMER: 'customer',
  UNBLU: 'unblu',
  MICROSOFT_TEAMS: 'teams',
  GOOGLE_MEET: 'meet',
  GOTO_MEETING: 'gotomeeting',
  WEBEX: 'webex',
  WILL_CALL_YOU: 'wewillcallyou',
  METAVERSE: 'metaverse',
  APPOINTMENT_LOCATION: 'appointment_location',
  KMEET: 'kmeet'
};

export const EXPORT_API_TYPE = {
  EVENT_OVERVIEW: 'event_overview',
  EVENT_DETAIL: 'event_detail',
  SLOT_DETAIL: 'slot_detail',
};

const brandWebsite = (environment as any).brandUrls?.BRAND_WEBSITE || 'https://www.calenso.com';
const brandName = environment.brandName || 'Calenso';

export const EMAIL_TEMPLATE_CONST = {
  de_CH: {
    finish: 'Freundliche Grüsse<br>[PARTNER_NAME]',
    footer: `Diese E-Mail wurde automatisch von <a href="${brandWebsite}" target="_blank">${brandName}</a> erzeugt.`,
    intro: 'Du hast erfolgreich einen Termin bei der Firma <b>[PARTNER_NAME]</b> in [LOCATION] vereinbart. <br><br>Wir haben den Termin direkt dieser E-Mail angehängt, damit Du ihn bequem in deinen Kalender einfügen kannst!',
    salutation: 'Hallo [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  en_US: {
    finish: 'Kind regards<br>[PARTNER_NAME]',
    footer: `This email was automatically generated by <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'You have successfully arranged an appointment with the company <b>[LOCATION]</b> in [ORT]. <br><br>We have attached the appointment directly to this e-mail so that you can easily add it to your calendar!',
    salutation: 'Dear [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  it_CH: {
    finish: 'Cordiali saluti<br>[PARTNER_NAME]',
    footer: `Questa e-mail è stata generata automaticamente da <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'hai fissato un appuntamento presso l\'azienda <b>[PARTNER_NAME]</b> di [LOCATION]. <br><br>Abbiamo allegato l\'appuntamento direttamente a questa e-mail per consentirti di inserirlo comodamente nel tuo calendario.',
    salutation: 'Salve [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  fr_CH: {
    finish: 'Meilleures salutations<br>[PARTNER_NAME]',
    footer: `Cet e-mail a été généré automatiquement par <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'Vous avez organisé avec succès plusieurs rendez-vous avec la société <b> [PARTNER_NAME] </b> dans [LOCATION]. <br><br>Nous avons joint les dates directement à cet e-mail, afin que vous puissiez facilement les ajouter dans votre calendrier!',
    salutation: 'Bonjour [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  nl_NL: {
    finish: 'Met vriendelijke groet<br>[PARTNER_NAME]',
    footer: `Deze e-mail werd automatisch gegenereerd door <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'U hebt met succes verschillende vergaderingen georganiseerd met het bedrijf <b> [PARTNER_NAME] </b> in [LOCATION]. <br><br>We hebben de data direct bij deze e-mail gevoegd, zodat u ze gemakkelijk in uw agenda kunt zetten!',
    salutation: 'Goeiedag, [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  fi_FI: {
    finish: 'Ystävällisin terveisin<br>[PARTNER_NAME]',
    footer: `Tämän sähköpostin on luonut automaattisesti <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'U hebt met succes verschillende vergaderingen georganiseerd met het bedrijf <b> [PARTNER_NAME] </b> in [LOCATION]. <br><br>We hebben de data direct bij deze e-mail gevoegd, zodat u ze gemakkelijk in uw agenda kunt zetten!',
    salutation: 'Rakas, [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  pl_PL: {
    finish: 'Z poważaniem<br>[PARTNER_NAME]',
    footer: `Ten e-mail został automatycznie wygenerowany przez <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'Udało Ci się zorganizować kilka spotkań z firmą <b> [PARTNER_NAME] </b> w [LOCATION]. <br><br>Daty załączyliśmy bezpośrednio do tego e-maila, więc możesz je łatwo umieścić w swoim kalendarzu.!',
    salutation: 'Droga, [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  es_ES: {
    finish: 'Saludos<br>[PARTNER_NAME]',
    footer: `Este correo ha sido generado automáticamente <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'Usted ha completado con éxito varios versichtungen organizand con la empresa <b> [PARTNER_NAME] </b> en [LOCATION]. <br><br>Hemos adjuntado los datos directamente a este e-mail, para que puedas ponerlos fácilmente en tu calendario!',
    salutation: 'Amar, [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
  sv_SE: {
    finish: 'Med vänlig hälsning<br>[PARTNER_NAME]',
    footer: `Detta e-postmeddelande har genererats automatiskt av <a href="${brandWebsite}" target="_blank">${brandName}</a>.`,
    intro: 'Du har lyckats ordna flera möten med företaget <b> [PARTNER_NAME] </b> i [LOCATION]. <br><br>Vi har bifogat datumen direkt till det här e-postmeddelandet, så att du enkelt kan lägga in dem i din kalender.',
    salutation: 'Väg, [CUSTOMER_PRENAME] [CUSTOMER_LASTNAME]',
  },
};

export const RESELLER_CONSTANTS = {
  PAYMENTS: 'PAYMENTS',
  REFERRALS: 'REFERRALS',
  INVITATIONS: 'INVITATIONS',
};

export const TEMPLATE_TYPES = [
  {
    display: 'email',
    value: 'email',
  },
  {
    display: 'sms',
    value: 'sms',
  },
  {
    display: 'general',
    value: 'general',
  },
];

export const RELEASE_NOTE_TYPES: { id: number; description: string }[] = [
  {
    id: 1,
    description: 'Bugfixing',
  },
  {
    id: 2,
    description: 'New Functions',
  },
  {
    id: 3,
    description: 'Hotfix',
  },
];

export const LANG_TYPES: {
  display: string;
  value: string;
  langIdentifer: string;
}[] = [
    {
      display: 'german',
      value: 'de',
      langIdentifer: 'de_CH',
    },
    {
      display: 'french',
      value: 'fr',
      langIdentifer: 'fr_CH',
    },
    {
      display: 'english',
      value: 'en',
      langIdentifer: 'en_US',
    },
    {
      display: 'italian',
      value: 'it',
      langIdentifer: 'it_CH',
    },
    {
      display: 'dutch',
      value: 'nl',
      langIdentifer: 'nl_NL',
    },
    {
      display: 'finnish',
      value: 'fi',
      langIdentifer: 'fi_FI',
    },
    {
      display: 'polish',
      value: 'pl',
      langIdentifer: 'pl_PL',
    },
    {
      display: 'spanish',
      value: 'es',
      langIdentifer: 'es_ES',
    },
    {
      display: 'swedish',
      value: 'sv',
      langIdentifer: 'sv_SE',
    },
  ];

export const BOTTOM_TYPES: {
  display: string;
  value: string;
}[] = [
    {
      display: 'bottom_right',
      value: 'bottom-right',
    },
    {
      display: 'bottom_left',
      value: 'bottom-left',
    },
  ];

export const TRIGGER_TYPE = {
  IMMEDIATELY: 1,
};

export const CALIO_STANDARD_COLORS = {
  WHITE: '#FFFFFF',
  VIOLET: '#5B45C9',
};

export const SALUTATION_TYPES: { display: string, value: string }[] = [
  {
    display: 'mr',
    value: 'm',
  },
  {
    display: 'ms',
    value: 'f',
  },
  {
    display: 'other',
    value: 'o',
  },
];


export const SMART_ACTION_INTERVALS: { display: string; value: string }[] = [
  {
    display: 'daily',
    value: 'daily',
  },
  {
    display: 'weekly',
    value: 'weekly',
  },
  {
    display: 'monthly',
    value: 'monthly',
  },
  {
    display: 'yearly',
    value: 'yearly',
  },
];

// Feature (add-on) names that unlock a provider outside its `allowedRegions`.
// Never bypasses `allowedBrands`.
export const PROVIDER_ADDON_FEATURES = {
  SENDGRID: 'is_sendgrid_enabled',
  TWILIO: 'is_twilio_enabled',
} as const;

export const SMS_PROVIDERS: SmsProviderOption[] = [
  {
    value: `SMSAPI`,
    slug: 'smsapi',
    prefRegion: 'EU (PL)',
    allowedRegions: ['eu'],
  },
  {
    value: `Brevo`,
    slug: 'sendinblue',
    prefRegion: 'EU (DE)',
    allowedRegions: ['eu'],
  },
  {
    value: `eCall by F24`,
    slug: 'ecall',
    prefRegion: 'CH',
    allowedRegions: ['eu'],
  },
  {
    value: 'Swisscom',
    slug: 'swisscom',
    prefRegion: 'CH',
    allowedRegions: ['eu'],
  },
  {
    value: 'Twilio',
    slug: 'twilio',
    prefRegion: 'Global',
    allowedRegions: ['us'],
    regionUnlockFeature: PROVIDER_ADDON_FEATURES.TWILIO,
  },
];

export const EMAIL_PROVIDERS: EmailProviderOption[] = [
  {
    value: 'Brevo',
    slug: 'brevo',
    allowedRegions: ['eu'],
  },
  {
    value: 'Microsoft 365',
    slug: 'microsoft365',
    // no allowedRegions → available in all regions
  },
  {
    value: 'SMTP',
    slug: 'smtp',
    // no allowedRegions → available in all regions
  },
  {
    value: 'SendGrid',
    slug: 'sendgrid',
    allowedRegions: ['us'],
    regionUnlockFeature: PROVIDER_ADDON_FEATURES.SENDGRID,
  },
];

export const SMS_PROVIDERS_VALUE = {
  SMS_API: 'smsapi',
  SEND_IN_BLUE: 'sendinblue',
  ECALL: 'ecall',
  SWISSCOM: 'swisscom',
  TWILIO: 'twilio'
};

export const EMAIL_PROVIDERS_VALUE = {
  BREVO: 'brevo',
  SMTP: 'smtp',
  MICROSOFT365: 'microsoft365',
  SENDGRID: 'sendgrid'
};

export const ENTITY_TYPE: { id: number; value: string }[] = [
  {
    id: 1,
    value: `resource`,
  },
  {
    id: 2,
    value: `appointment`,
  },
];

export const SAFERPAY_API_URL: { text: string; value: string }[] = [
  {
    text: `TEST (https://test.saferpay.com/api)`,
    value: `https://test.saferpay.com/api`,
  },
  {
    text: `PROD (https://www.saferpay.com/api)`,
    value: `https://www.saferpay.com/api`,
  },
];

export const UNBLU_AUTH_TYPE: { value: string; text: string }[] = [
  {
    text: `external_calendar_settings_component.unblu_basic_auth`,
    value: `basic`,
  },
  {
    text: `external_calendar_settings_component.unblu_OAuth2`,
    value: `oauth`,
  },
];

export const PARTNER_SETTING_TYPES: { [key: string]: string } = {
  STRING: 'string',
  INT: 'int',
  BOOLEAN: 'boolean',
};

export const DEFAULT_SELECTED_STORE_WORKERS_LIMIT_FOR_CALENDAR = 5;

export const SMART_ACTION_EXPORT_DURATION: { label: string; value: number }[] =
  [
    {
      label: 'smart_actions_component.all',
      value: 0,
    },
    {
      label: 'smart_actions_component.this_year',
      value: 1,
    },
    {
      label: 'smart_actions_component.last_year',
      value: 2,
    },
    {
      label: 'smart_actions_component.last_two_year',
      value: 3,
    },
  ];

export const WEBHOOK_ENDPOINT_TYPE = [
  {
    name: 'appointment',
    category: 'booking.created',
    label: 'appointment.booking.created',
    id: 1,
  },
  {
    name: 'appointment',
    category: 'booking.canclled',
    label: 'appointment.booking.cancelled',
    id: 2,
  },
  {
    name: 'appointment',
    category: 'booking.updated',
    label: 'appointment.updated',
    id: 11,
  },
  {
    name: 'appointment',
    category: 'booking.rebooked',
    label: 'appointment.booking.rebooked',
    id: 12,
  },
  {
    name: 'event',
    category: 'booking.created',
    label: 'event.booking.created',
    id: 3,
  },
  {
    name: 'event',
    category: 'booking.cancelled',
    label: 'event.booking.cancelled',
    id: 4,
  },
  {
    name: 'event',
    category: 'booking.rebooked',
    label: 'event.booking.rebooked',
    id: 13,
  },
  {
    name: 'appointment',
    category: 'reminder',
    label: 'appointment.reminder',
    id: 14,
  },
  {
    name: 'event',
    category: 'reminder',
    label: 'event.reminder',
    id: 15,
  },
  {
    name: 'appointment',
    category: 'manual.booking.created',
    label: 'appointment.manual.booking.created',
    id: 5,
  },
  {
    name: 'event',
    category: 'manual.booking.created',
    label: 'event.manual.booking.created',
    id: 6,
  },
  {
    name: 'customer',
    category: 'created',
    label: 'customer.created',
    id: 7,
  },
  {
    name: 'customer',
    category: 'updated',
    label: 'customer.updated',
    id: 8,
  },
  {
    name: 'customer',
    category: 'deleted',
    label: 'customer.deleted',
    id: 9,
  },
  {
    name: 'lead',
    category: 'created',
    label: 'lead.created',
    id: 10,
  },
];

export const BLOCK_RESOURCE_MODE = [
  { display: 'booking_widget_settings.block_booking_time', value: '1' },
  { display: 'booking_widget_settings.block_entire_day', value: '2' },
  { display: 'booking_widget_settings.block_half_day', value: '3' },
];

export const BOOKING_REDIRECTION_VIEWS = {
  BOOKING_SUMMARY_VIEW: 'booking_summary_view',
  BOOKING_SUCCESS_VIEW: 'booking_success_view',
};

export const BOOKING_REDIRECTION_OPTIONS = [
  { display: 'booking_widget_settings.booking_summary_view', value: BOOKING_REDIRECTION_VIEWS.BOOKING_SUMMARY_VIEW },
  { display: 'booking_widget_settings.booking_success_view', value: BOOKING_REDIRECTION_VIEWS.BOOKING_SUCCESS_VIEW },
];

export const CROSS_SELLING_CATEGORY_FILTER = {
  SAME: 0,
  OTHER: 1,
  ALL: 2,
} as const;

export const CROSS_SELLING_CATEGORY_FILTER_OPTIONS = [
  { display: 'booking_widget_settings.cross_sell_filter_same', value: CROSS_SELLING_CATEGORY_FILTER.SAME },
  { display: 'booking_widget_settings.cross_sell_filter_other', value: CROSS_SELLING_CATEGORY_FILTER.OTHER },
  { display: 'booking_widget_settings.cross_sell_filter_all', value: CROSS_SELLING_CATEGORY_FILTER.ALL },
];

export const WIDGET_HINT_COLORS = [
  { key: 'primary', value: 'Primary' },
  { key: 'secondary', value: 'Secondary' },
  { key: 'success', value: 'Success' },
  { key: 'danger', value: 'Danger' },
  { key: 'warning', value: 'Warning' },
  { key: 'info', value: 'Info' },
  { key: 'light', value: 'Light' },
  { key: 'dark', value: 'Dark' },
];

export const BOOKING_WIDGET_LIST: { display: string; value: string; feature?: string }[] = [
  { display: 'booking_widget_settings.internal_appointment', value: WIDGET_APPOINTMENT_TYPE.INTERNAL_APPOINTMENT },
  { display: 'booking_widget_settings.external_appointment', value: WIDGET_APPOINTMENT_TYPE.EXTERNAL_APPOINTMENT },
  { display: 'booking_widget_settings.external_group_appointment', value: WIDGET_APPOINTMENT_TYPE.EXTERNAL_GROUP_APPOINTMENT },
  { display: 'booking_widget_settings.external_pre_defined_slots', value: WIDGET_APPOINTMENT_TYPE.EXTERNAL_PRE_DEFINED_SLOTS, feature: 'is_resource_planning_enabled' },
  { display: 'booking_widget_settings.external_tour', value: WIDGET_APPOINTMENT_TYPE.EXTERNAL_TOUR, feature: 'is_dynamic_combi_enabled' }
];

export const SLOTS_GROUP_ORDERING = [
  { key: 'general.ascending', value: 'asc' },
  { key: 'general.descending', value: 'desc' }
];

export const GROUP_APPOINTMENTS_FILTER_BEHAVIOR_OPTIONS = [
  { display: 'AND', value: 'and' },
  { display: 'OR', value: 'or' }
];
export const GROUP_APPOINTMENTS_FILTER_BEHAVIOUR_TYPE = {
  AND: 'and',
  OR: 'or'
};

export const BOOKING_QUESTION_TYPE_FEATURE = [
  {
    feature: 'is_select_booking_question_type_enabled',
    bookingQuestionType: 'select'
  },
  {
    feature: 'is_checkbox_booking_question_type_enabled',
    bookingQuestionType: 'checkbox'
  },
  {
    feature: 'is_textarea_booking_question_type_enabled',
    bookingQuestionType: 'textarea'
  },
  {
    feature: 'is_input_booking_question_type_enabled',
    bookingQuestionType: 'text'
  },
  {
    feature: 'is_upload_booking_question_type_enabled',
    bookingQuestionType: 'file'
  },
  {
    feature: 'is_radio_booking_question_type_enabled',
    bookingQuestionType: 'radio'
  },
  {
    feature: 'is_date_booking_question_type_enabled',
    bookingQuestionType: 'date'
  },
  {
    feature: 'is_information_booking_question_type_enabled',
    bookingQuestionType: 'information'
  },
  {
    feature: 'is_number_select_booking_question_type_enabled',
    bookingQuestionType: 'number-select'
  },
  {
    feature: 'is_image_select_booking_question_type_enabled',
    bookingQuestionType: 'image-select'
  },
  {
    feature: 'is_card_select_booking_question_type_enabled',
    bookingQuestionType: 'card-select'
  },
  {
    feature: 'is_worker_select_booking_question_type_enabled',
    bookingQuestionType: 'worker-select'
  },
  {
    feature: 'is_store_select_booking_question_type_enabled',
    bookingQuestionType: 'store-select'
  }
];

// commented out for now as we don't use
// export const GDPR_DOC_LINK = "https://my.calenso.com/files/pdf/Calenso_DPA.pdf";

export const CALENDLY_AUTH_URL = 'https://auth.calendly.com/oauth/authorize';

export const RECURRENCE_TYPE: { label: string; value: string }[] = [
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Yearly',
    value: 'yearly'
  },
  {
    label: 'Onetime',
    value: 'onetime'
  }
];

export const PAYMENT_TYPE: { label: string; value: string }[] = [
  {
    label: 'Invoice',
    value: 'invoice'
  },
  {
    label: 'Creditcard',
    value: 'creditcard'
  },
];

export const SMART_ACTIONS_PERMISSION_REQUIRED = {
  1: 'is_thank_you_mail_after_appointment_smartaction_enabled',
  2: 'is_satisfaction_survey_smartaction_enabled',
  5: 'is_mass_cancellation_smartaction_enabled',
  6: 'is_monthly_group_appointment_participant_export_smartaction_enabled',
  7: 'is_mail_before_appointment_smartaction_enabled',
  8: 'is_monthly_export_smartaction_enabled'
};

export const CUSTOMER_CSTM_FIELD_TITLE_LIST = [
  { id: 0, name: '--' },
  { id: 1, name: 'Dr.' },
  { id: 2, name: 'Dr. med.' },
  { id: 3, name: 'Prof.' },
  { id: 4, name: 'Prof. Dr.' }
];

export const SUBSCRIPTION_CANCELLATION_REASONS = [
  { id: 1, name: 'technical_issue' },
  { id: 2, name: 'too_expensive' },
  { id: 3, name: 'switching_to_another_product' },
  { id: 4, name: 'company_shutdown' },
  { id: 5, name: 'missing_feature' },
  { id: 6, name: 'too_complicated' },
  { id: 7, name: 'other' }
];

export const NOTIFICATION_TYPE = [{
  display: 'email',
  value: 'email'
}, {
  display: 'sms',
  value: 'sms'
}, {
  display: 'both',
  value: 'both'
}];

export const CHILD_TO_PARENT_EDIT_EVENTS = {
  DESCRIPTION: 'PARTNER.DESCRIPTION',
  APPOINTMENT_TAB: 'BOOKING_PAGE_HIDE_APPOINTMENT_TAB',
  EVENT_TAB: 'BOOKING_PAGE_HIDE_EVENT_TAB',
  EMPLOYEE_TAB: 'BOOKING_PAGE_HIDE_EMPLOYEE_TAB',
  STORE_TAB: 'BOOKING_PAGE_HIDE_STORE_TAB',
  ABOUT_US_TAB: 'BOOKING_PAGE_HIDE_ABOUT_US_TAB',
  RATINGS_TAB: 'BOOKING_PAGE_HIDE_RATINGS_TAB',
  EDIT_BUSINESS_HOURS: 'PARTNER.BUSINESS_HOURS',
  CALENSO_EDIT_BOOKING_PAGE_FIELDS: 'CALENSO.EDIT_BOOKING_PAGE_FIELDS',
  PARTNER_SETTING: 'PARTNER.SETTINGS',
  PARTNER_BACKGROUND_IMAGE: 'PARTNER.BACKGROUND',
  PARTNER_LOGO: 'PARTNER.LOGO'
};

export const WIDGET_TYPES = [
  {
    key: 'startsite_component.appointments',
    value: APP_CONSTANTS.APPOINTMENT,
    permission: ['read:appointments', 'read:own:appointments', 'read:own:store:appointments', 'read:own:service:appointments']
  },
  {
    key: 'startsite_component.compact',
    value: APP_CONSTANTS.COMPACT,
    permission: ['read:appointments', 'read:own:appointments', 'read:own:store:appointments', 'read:own:service:appointments']
  },
  {
    key: 'startsite_component.group_appointments',
    value: APP_CONSTANTS.EVENT,
    permission: ['read:events', 'read:own:events', 'read:own:store:events']
  },
  {
    key: 'startsite_component.conference',
    value: APP_CONSTANTS.CONFERENCE,
    permission: ['read:booking-links'],
    feature: 'is_booking_links_feature_enabled'
  },
  {
    key: 'startsite_component.pre_defined_slots',
    value: APP_CONSTANTS.PRE_DEFINED_SLOTS,
    permission: ['read:appointments', 'read:own:appointments', 'read:own:store:appointments'],
    feature: 'is_resource_planning_enabled'
  },
  {
    key: 'startsite_component.tour',
    value: APP_CONSTANTS.TOUR,
    permission: ['read:appointments', 'read:own:appointments', 'read:own:store:appointments', 'read:own:service:appointments'],
    feature: 'is_dynamic_combi_enabled'
  }
];

export const STATUS_TYPES = {
  failed: 'Failed',
  opened: 'Opened',
  sent: 'Sent'
};

export const LOCATION_DEPENDENCIES = [
  { label: 'inherit', value: '' },
  { label: 'true', value: true },
  { label: 'false', value: false }
];

export const ICS_EMPLOYEE_METHOD_OPTIONS = [
  { value: '', display: 'app_employee_form.ics_method_default_option' },
  { value: 'PUBLISH', display: 'ics_settings.method_option_publish' },
  { value: 'REQUEST', display: 'ics_settings.method_option_request' }
];

export const EMAIL_SMS_CONST = {
  email: 'Email',
  sms: 'SMS'
};

export const AUTHY_APP_LINKS = {
  android: 'https://play.google.com/store/apps/details?id=com.authy.authy',
  ios: 'https://apps.apple.com/us/app/authy/id494168017'
};

export const CUSTOM_CSS_WIDGET_TYPES = [
  { key: 'wt_widget', value: 'widget' },
  { key: 'wt_smartwidget', value: 'smart_widget' },
  { key: 'wt_bookingpage', value: 'booking_page' },
  { key: 'wt_appointment_landing_page', value: 'appointment_landing_page' },
  { key: 'wt_event_landing_page', value: 'event_landing_page' },
];

export const UTILISATION_REPORT_RANGE_ENTITY = [
  { key: 'stores', value: 'utilization_report.store' },
  { key: 'workers', value: 'utilization_report.resource' },
];

export const ROLES_IMPORT_ENTITY = [
  { key: 'store', value: 'utilization_report.store' },
  { key: 'worker', value: 'utilization_report.resource' },
];

export const VALID_IMAGE_FILE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/x-icon'];
export const VALID_EXCEL_FILE_TYPES = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const MIME_TYPES = {
  IMAGE: 'image/jpeg,image/jpg,image/png,image/gif',
  DOC: 'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export const PREFERRED_COUNTRIES = ['ch', 'de', 'fr', 'it', 'nl', 'fi', 'pl', 'es', 'se', 'at'];

export const INTL_TEL_INPUT = {
  UTIL_SCRIPT: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.0.0/js/utils.js',
  // Backend-proxied geo lookup — keeps the upstream provider token off the public bundle
  IPLOOKUP_URL: `${environment.hostName}/api/v1/geo/lookup`
};

export const MAX_SLOTS_VISIBLE_LENGTH = 5;

export const BOOKINGPAGE_UI_MODES = [{ value: 'grid', display: 'general.grid' }, { value: 'list', display: 'general.list' }];

export const CURRENCY_SYMBOL = {
  CHF: 'CHF',
  EUR: 'EUR'
};

export const EVENT_SLOTS_LIMIT = 30;

export const JOB_QUEUE_RECORDS_LIMIT = 50;

export const MAX_LIMIT = {
  url_min_length: 2,
  url_length: 2000,
  lead_time: 672,
  followup_time: 336,
  price: 99999999,
  duration: 1440,
  widgetConfigurations: 15,
  conferenceTitle: 255,
  conferenceDescription: 1000,
  bookingTypeNameMinLength: 2,
  bookingTypeNameMaxLength: 255,
  bookingTypeAttributeMinLength: 2,
  bookingTypeAttributeMaxLength: 255,
  resourceBookingTypeAttributesMinLength: 0,
  resourceBookingTypeAttributesMaxLength: 49999,
  appointmentServiceTitleMaxLength: 255,
  appointmentServiceDescriptionMaxLength: 500,
  workersPaginationLimit: 30,
  cancellation_to: 3000,
  skuMaxLength: 255
};

export const EVENT_SLOT_TIME_DURATION = [{
  value: 15,
  label: 'event_time_slots.xx_min',
  hideValue: false
}, {
  value: 30,
  label: 'event_time_slots.xx_min',
  hideValue: false
}, {
  value: 45,
  label: 'event_time_slots.xx_min',
  hideValue: false
}, {
  value: 60,
  label: 'event_time_slots.xx_min',
  hideValue: false
}];

export const EVENT_SLOT_TIME_DEFAULT_DURATION = 30;

export const EVENT_REPEATING_DAYS_LIST = [{
  value: 30,
  label: 'event_time_slots.days',
  hideValue: false
}, {
  value: 60,
  label: 'event_time_slots.days',
  hideValue: false
}, {
  value: 90,
  label: 'event_time_slots.days',
  hideValue: false
}, {
  value: 365,
  label: 'event_time_slots.days',
  hideValue: false
}];

export const LANDING_PAGE_MODE = {
  admin: 'admin',
  user: 'user',
};

export const SECTION = {
  ADMIN_AREA: 'admin-area',
  BILLING: 'billing',
  NOTIFICATION: 'notification',
  SECURITY: 'security',
  ANALYTICS: 'analytics',
  HELP_AND_SUPPORT: 'help-support',
  SETTINGS: 'settings',
  MASTER_DATA: 'master-data'
};

export enum THEME {
  OLD,
  NEW
}

export const UI_VIEW_MODE = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  LAPTOP: 'LAPTOP'
};

export const EMAIL_PROVIDERS_MAPPING = {
  smtp: 'SMTP',
  mailpit: 'Mailpit',
  sendinblue: 'Brevo',
  brevo: 'Brevo',
  microsoft365: 'Microsoft 365',
  'brevo (ms365-fallback)': 'Brevo (Microsoft 365 Fallback)'
};

export const APPOINTMENT_TYPE = {
  LEAD: 'lead',
  FOLLOWUP: 'followup',
} as const;

export const RESELLER_WHITELIST_PATH = ['appointments', 'events', 'customers', 'settings'];

export const HIGHLIGHT_TYPES = {
  global: 'global',
  service: 'service',
  worker: 'worker'
} as const;

export const INDUSTRY_LIST = [
  { key: 'reseller_component.industry_options.banken_finanzwesen', value: 'banking' },
  { key: 'reseller_component.industry_options.behörden_verwaltungen', value: 'administrations' },
  { key: 'reseller_component.industry_options.bildungseinrichtungen', value: 'education' },
  { key: 'reseller_component.industry_options.dienstleistungsbranche', value: 'services' },
  { key: 'reseller_component.industry_options.einzelhandel_ecommerce', value: 'ecommerce' },
  { key: 'reseller_component.industry_options.eventmanagement_veranstaltungen', value: 'event_management' },
  { key: 'reseller_component.industry_options.gesundheitswesen_medizin', value: 'health' },
  { key: 'reseller_component.industry_options.immobilien_bauwesen', value: 'real_estate' },
  { key: 'reseller_component.industry_options.personalwesen_recruiting', value: 'hr' },
  { key: 'reseller_component.industry_options.rechtswesen_kanzleien', value: 'law' },
  { key: 'reseller_component.industry_options.schönheit_wellness', value: 'beauty' },
  { key: 'reseller_component.industry_options.sport_fitness', value: 'sport' },
  { key: 'reseller_component.industry_options.unternehmensberatung', value: 'consulting' },
  { key: 'reseller_component.industry_options.versicherungen_vorsorge', value: 'insurance' },
  { key: 'reseller_component.industry_options.sonstigebranchen', value: 'other' }
];

export const COMPANY_SIZE = [
  { key: '1', value: '1' },
  { key: '2-10', value: '2-10' },
  { key: '11-50', value: '11-50' },
  { key: '51-250', value: '51-250' },
  { key: '251-1000', value: '251-1000' },
  { key: '1001-5000', value: '1001-5000' },
  { key: '5001-100000', value: '5001-20000' },
  { key: '0', value: '0' }
];

export const VAT_TYPES = [
  { display: 'booking_widget_settings.inclusive', value: 'inclusive' },
  { display: 'booking_widget_settings.exclude', value: 'exclude' },
  { display: 'booking_widget_settings.plus', value: 'plus' }
];

export const CAPTCHA_OPTIONS = {
  CALENSO_DEFAULT: 'calenso_default',
  FRIENDLY: 'friendly'
} as const;

export const CAPTCHA_TYPE = [
  { display: 'booking_widget_settings.calenso_default', value: CAPTCHA_OPTIONS.CALENSO_DEFAULT },
  { display: 'booking_widget_settings.friendly_captcha', value: CAPTCHA_OPTIONS.FRIENDLY }
];

export const COUPON_TYPE = {
  COUPON: 'coupon',
  VOUCHER: 'voucher'
};

export const TRANSACTION_TYPE = {
  CREDIT: 'cr',
  DEBIT: 'dr'
};

export const COUPON_TYPE_ID = {
  COUPON: null,
  VOUCHER: 7
};

export const WIDGET_PROTECTION_TYPE = {
  PASSWORD: 'password',
  OTP: 'otp'
} as const;

export const WIDGET_PROTECTION_TYPE_OPTIONS = [
  { display: 'booking_widget_settings.password', value: WIDGET_PROTECTION_TYPE.PASSWORD },
  { display: 'booking_widget_settings.otp', value: WIDGET_PROTECTION_TYPE.OTP }
];

export const OTP_VERIFICATION_TYPE = {
  EMAIL: 'email',
  SMS: 'sms'
} as const;

export const OTP_VERIFICATION_TYPE_OPTIONS = [
  { display: 'booking_widget_settings.email', value: OTP_VERIFICATION_TYPE.EMAIL },
  { display: 'booking_widget_settings.sms', value: OTP_VERIFICATION_TYPE.SMS }
];

export const OTP_COMPLEXITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'
};

export const OTP_COMPLEXITY_OPTIONS = [
  { display: 'booking_widget_settings.low', value: OTP_COMPLEXITY.LOW },
  { display: 'booking_widget_settings.medium', value: OTP_COMPLEXITY.MEDIUM },
  { display: 'booking_widget_settings.high', value: OTP_COMPLEXITY.HIGH }
];

export const WIDGET_TIME_FORMAT = {
  AUTO: 'auto',
  HOURS_24: '24_hours',
  HOURS_12: '12_hours'
} as const;

export const WIDGET_TIME_FORMAT_OPTIONS = [
  { display: 'booking_widget_settings.time_format_auto', value: WIDGET_TIME_FORMAT.AUTO },
  { display: 'booking_widget_settings.time_format_24_hours', value: WIDGET_TIME_FORMAT.HOURS_24 },
  { display: 'booking_widget_settings.time_format_12_hours', value: WIDGET_TIME_FORMAT.HOURS_12 }
];

export const WIDGET_DISPLAY_TIMEZONE_SOURCE = {
  VISITOR: 'visitor',
  PARTNER: 'partner'
} as const;
export type WidgetDisplayTimezoneSource =
  typeof WIDGET_DISPLAY_TIMEZONE_SOURCE[keyof typeof WIDGET_DISPLAY_TIMEZONE_SOURCE];

export const MEETING_TYPE_SELECTION_UI_MODE = {
  DROPDOWN: 'dropdown',
  TILES: 'tiles'
} as const;
export type MeetingTypeSelectionUiMode =
  typeof MEETING_TYPE_SELECTION_UI_MODE[keyof typeof MEETING_TYPE_SELECTION_UI_MODE];

export const WIDGET_RESTRICTION_PARAMETERS = {
  CUSTOMER_UUID: 'customer_uuid',
  WORKER_ID: 'worker_id',
  WORKER_EMAIL: 'worker_email',
  STORE_ID: 'store_id',
  SERVICE_ID: 'service_id',
  CUSTOMER_TOKEN: 'customer_token'
} as const;

export const WIDGET_RESTRICTION_PARAMETERS_OPTIONS = [
  { display: 'booking_widget_settings.customer_uuid', value: WIDGET_RESTRICTION_PARAMETERS.CUSTOMER_UUID },
  { display: 'booking_widget_settings.worker_id', value: WIDGET_RESTRICTION_PARAMETERS.WORKER_ID },
  { display: 'booking_widget_settings.service_id', value: WIDGET_RESTRICTION_PARAMETERS.SERVICE_ID },
  { display: 'booking_widget_settings.store_id', value: WIDGET_RESTRICTION_PARAMETERS.STORE_ID },
  { display: 'booking_widget_settings.customer_token', value: WIDGET_RESTRICTION_PARAMETERS.CUSTOMER_TOKEN }
];

export const IFRAME_RESIZER_VERSION = {
  IFRAME_RESIZER_VERSION_4_3_5: '4.3.5',
  IFRAME_RESIZER_VERSION_5_5_X: '5.5.0'
} as const;

export const IFRAME_RESIZER_VERSION_OPTIONS = [
  { display: 'booking_widget_settings.iframe_resizer_version_4_3_5', value: IFRAME_RESIZER_VERSION.IFRAME_RESIZER_VERSION_4_3_5 },
  { display: 'booking_widget_settings.iframe_resizer_version_5_5_x', value: IFRAME_RESIZER_VERSION.IFRAME_RESIZER_VERSION_5_5_X }
];

export const WORKER_BOOKABLE_FILTER_OPTIONS = [
  { label: 'appointment_status_list_component.yes', value: 'yes' },
  { label: 'appointment_status_list_component.no', value: 'no' }
];

export const WORKER_CONNECTION_STATUS_FILTER = {
  CONNECTED: 'connected',
  NOT_CONNECTED: 'not_connected',
  FAULTY: 'faulty'
} as const;

export type WorkerConnectionStatusFilter = typeof WORKER_CONNECTION_STATUS_FILTER[keyof typeof WORKER_CONNECTION_STATUS_FILTER];

export const WORKER_CONNECTION_STATUS_FILTER_OPTIONS = [
  { label: 'general.connected', value: WORKER_CONNECTION_STATUS_FILTER.CONNECTED },
  { label: 'general.not_connected', value: WORKER_CONNECTION_STATUS_FILTER.NOT_CONNECTED },
  { label: 'meetings_settings_component.failed_connection', value: WORKER_CONNECTION_STATUS_FILTER.FAULTY }
];

export const PASSWORD_MODE = {
  RESET: 'reset',
  SET: 'set'
} as const;

export type PasswordMode = typeof PASSWORD_MODE[keyof typeof PASSWORD_MODE];

export const HAS_CUSTOMER_ATTENDED_OPTIONS = [
  { label: 'appointment_status_list_component.yes', value: 1 },
  { label: 'appointment_status_list_component.no', value: 0 }
];

export const OTP_RESTRICTED_COMPONENTS = {
  APPOINTMENT_BOOKING: 'appointment_booking',
  APPOINTMENT_LANDING_PAGE: 'appointment_landing_page',
  ADMIN_APPOINTMENT_LANDING_PAGE: 'admin_appointment_landing_page',
  APPOINTMENT_CANCELLATION: 'appointment_cancellation',
  ADMIN_APPOINTMENT_CANCELLATION: 'admin_appointment_cancellation',
  APPOINTMENT_REBOOK: 'appointment_rebook',
  ADMIN_APPOINTMENT_REBOOK: 'admin_appointment_rebook',
} as const;

export const OTP_RESTRICTED_COMPONENTS_OPTIONS = [
  { display: 'booking_widget_settings.appointment_booking', value: OTP_RESTRICTED_COMPONENTS.APPOINTMENT_BOOKING, disabled: false },
  { display: 'booking_widget_settings.appointment_landing_page', value: OTP_RESTRICTED_COMPONENTS.APPOINTMENT_LANDING_PAGE, disabled: false },
  { display: 'booking_widget_settings.admin_appointment_landing_page', value: OTP_RESTRICTED_COMPONENTS.ADMIN_APPOINTMENT_LANDING_PAGE, disabled: false },
  { display: 'booking_widget_settings.appointment_cancellation', value: OTP_RESTRICTED_COMPONENTS.APPOINTMENT_CANCELLATION, disabled: false },
  { display: 'booking_widget_settings.admin_appointment_cancellation', value: OTP_RESTRICTED_COMPONENTS.ADMIN_APPOINTMENT_CANCELLATION, disabled: false },
  { display: 'booking_widget_settings.appointment_rebook', value: OTP_RESTRICTED_COMPONENTS.APPOINTMENT_REBOOK, disabled: false },
  { display: 'booking_widget_settings.admin_appointment_rebook', value: OTP_RESTRICTED_COMPONENTS.ADMIN_APPOINTMENT_REBOOK, disabled: false },
];

